/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Removing_Repeat_Words_CompleteInputs */



/**
* | output |
* | --- |
* | "Removing repeat words complete" |
*
* @param {Removing_Repeat_Words_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const removing_repeat_words_complete = /** @type {((inputs?: Removing_Repeat_Words_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removing_Repeat_Words_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suppression des mots répétés terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernen von Wiederholungen vollständig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimozione delle parole ripetute completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаление повторяющихся слов завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminación completa de palabras repetidas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除重复词完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複した単語の削除が完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दोहराए गए शब्दों को पूरी तरह से हटा दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remoção de palavras repetidas concluída")
	return /** @type {LocalizedString} */ ("Removing repeat words complete")
});